import React from "react";
import { sanitizeSongName } from "../shared/utils/songs.utils";
import { Track } from "../spotify/spotify";

interface SongListProps {
    songs: Track[];
}

const SongList: React.FC<SongListProps> = ({ songs }) => (
    <div className="column-centered">
        <div className="column track-list">
            { 
                songs.map(song => (
                    <div key={song.id} className="row align-center mx-bw-5 my-2 md:my-3">
                        { song.album.images.length > 0 && <img src={song.album.images[0].url} alt="img" className="album-art-img" /> }
                        <div className="flex-grow self-stretch column justify-center text-lg ml-1 md:ml-3">
                            <p className="">{sanitizeSongName(song.name)}</p>
                            <i className="text-md">{song.artists.map(a => a.name).join(', ')}</i>
                        </div>
                        { 
                            song.preview_url ?
                            <audio controls className="ml-auto">
                                <source src={song.preview_url} type="audio/mp3" />
                            </audio> : 
                            <p className="opacity-50 ml-auto">(no preview available)</p>
                        }
                    </div>
                ))
            }
        </div>
    </div>
);

export default SongList;
